import {AnalyticsBaseOrderDto} from "../../../common/models/core/analytics-base-order-dto";
import {ModificationLineTransfer} from "../../../../../_models/_booking/composition-override-linker-transfer";

export enum SalesDtoKeys {
  id = 'id',
  locationId = 'locationId',
  timeInterval = 'timeInterval',
  compositionTypeId = 'compositionTypeId',
  orderId = 'orderId',
  pricePerUnit = 'pricePerUnit',
  quantity = 'quantity',
  compositionId = 'compositionId',
  compositionVariantKey = 'compositionVariantKey',
  compositionName = 'compositionName',
  modificationLines = 'modificationLines',
  bookingType = 'bookingType',
  isActive = 'isActive',
  hasSpecialTag = 'hasSpecialTag',
  sourceDetailsCost = 'sourceDetailsCost',
  revenueAfterTax = 'revenueAfterTax',
}

export class SalesDto extends AnalyticsBaseOrderDto {
  id: string;
  //locationId: string;
  timeInterval: number;
  //compositionTypeId: string;
  orderId: string;
  pricePerUnit: number;
  quantity: number;
  compositionId: string;
  compositionCompositeId: string;
  /**
   * The Feature #534 grouping key for `'individual'` mode: composition id + sorted swap ids, derived from
   * {@link compositionCompositeId} by `compositionVariantKey()` (the price-override segment is deliberately
   * dropped — a Sonderpreis does NOT open its own row). Equals {@link compositionId} whenever the composite id
   * is absent or malformed, so a trimmed projection degrades to combined instead of throwing.
   *
   * It is a real, filterable property (not a computed getter) because `FilterHelper.applyFilter` compares
   * `salesDto[filter.key]` — `FilterKeys.CompositionVariantKey` has to resolve to a stored field.
   */
  compositionVariantKey: string = '';
  compositionName: string; // remove in new Model
  /**
   * The line's rendered modification/default lines (`├ 4 cl Premium Gin`) as transmitted with the booking
   * (#197/#198). Always a real array here — `orderEdtoToBaseOrderElements` normalises the optional wire field
   * with `?? []` (#440) — so consumers never need their own guard.
   */
  modificationLines: ModificationLineTransfer[] = [];
  //paymentMethod: number;
  isActive: boolean = true;
  hasSpecialTag: boolean = false;
  sourceDetailsCost: number = 0;
  revenueAfterTax: number = 0;

  constructor(id: string, locationId: string, timeInterval: number, compositionTypeId: string, orderId: string, pricePerUnit: number, quantity: number, compositionId: string, compositionCompositeId: string, compositionName: string, bookingType: number, isActive: boolean = true, hasSpecialTag: boolean = false) {
    super(locationId, bookingType, compositionTypeId);

    this.locationId = locationId;
    this.orderId = orderId;
    this.timeInterval = timeInterval;
    this.id = id;
    //this.compositionTypeId = compositionTypeId;
    this.pricePerUnit = pricePerUnit;
    this.quantity = quantity;
    this.compositionId = compositionId;
    this.compositionCompositeId = compositionCompositeId;
    this.compositionVariantKey = compositionId;
    this.compositionName = compositionName;
    this.isActive = isActive;
    this.hasSpecialTag = hasSpecialTag;
  }

  static copy(baseOrderElementDto: SalesDto): SalesDto {
    let copy = new SalesDto(baseOrderElementDto.id, baseOrderElementDto.locationId, baseOrderElementDto.timeInterval, baseOrderElementDto.compositionTypeId, baseOrderElementDto.orderId, baseOrderElementDto.pricePerUnit, baseOrderElementDto.quantity, baseOrderElementDto.compositionId, baseOrderElementDto.compositionCompositeId, baseOrderElementDto.compositionName, baseOrderElementDto.bookingType, baseOrderElementDto.isActive, baseOrderElementDto.hasSpecialTag);
    copy.sourceDetailsCost = baseOrderElementDto.sourceDetailsCost;
    copy.revenueAfterTax = baseOrderElementDto.revenueAfterTax;
    // #534: both are set AFTER construction (the positional constructor is already unwieldy), so a copy that
    // forgot them would silently drop every swap row back into its combined row — and the employee-sales
    // zero-revenue duplicates in `createDuplicatedZeroRevenueSet` are exactly such copies.
    copy.compositionVariantKey = baseOrderElementDto.compositionVariantKey;
    copy.modificationLines = baseOrderElementDto.modificationLines;
    return copy;
  }

}
